<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                  class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}" [src]="logoEnterprise"
                    alt="" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> {{nameEnterprise}}</p>
                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferStoreWorkshopPrintModel.branchName}}</p>
                  <!-- Traslado Almacén Taller Consecutivo -->
                  <label id="t-traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-traslado-almacen-taller' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferStoreWorkshopPrintModel.consecutive}}</p>
                  <!-- Numero Alterno Traslado Almacén Taller -->
                  <label id="t-traslado-almacen-taller-alt-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-traslado-almacen-taller-alt' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="traslado-almacen-taller-alt-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferStoreWorkshopPrintModel.alterNumber}}</p>
                  <!--Dirección  -->
                  <label id="t-direccion-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion'
                    | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferStoreWorkshopPrintModel.branchAddress}}</p>
                  <!--Teléfono  -->
                  <label id="t-telefono-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferStoreWorkshopPrintModel.branchPhone}}</p>
                  <!-- Fecha Traslado -->
                  <label
                    id="t-fecha-traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-traslado-almacen-taller' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferStoreWorkshopPrintModel.dateTransferStoreWorkshop | date: 'dd/MM/yyyy'}}</p>
                  <!-- Tipo Traslado -->
                  <label id="t-tipo-traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-tipo-traslado-almacen-taller' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="tipo-traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferStoreWorkshopPrintModel.typeTransferStoreWorkshop }}</p>
                  <!-- Estado Traslado -->
                  <label
                    id="t-estado-traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-estado-traslado-almacen-taller' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="estado-traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferStoreWorkshopPrintModel.stateTransferStoreWorkshop }}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print
                  id="detalle-traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                  [columns]="columns" [data]="transferStoreWorkshopPrintModel.transferStoreWorkshopDetails"
                  [idMap]="idMap" [documentId]="transferStoreWorkshopPrintModel.transferStoreWorkshopId"
                  [footerVisible]="true" [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <div id="foot-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                class="foot mt-1 container-observations">
                <!-- Observaciones -->
                <label id="t-obs-traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-obs-traslado-almacen-taller' |
                  formatLabelPipe : elementsLabel}}</label>
                <p id="obs-traslado-almacen-taller-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="transferStoreWorkshopPrintModel.observation">
                  {{transferStoreWorkshopPrintModel.observation}}</p>
                <p id="linea-firma-revisado-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                  class="write-line" (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>
                <label id="t-linea-revisado-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-linea-revisado' | formatLabelPipe :
                  elementsLabel}}</label>
                <p id="linea-firma-entregado-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                  class="write-line" (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>
                <label id="t-linea-entregado-{{transferStoreWorkshopPrintModel.transferStoreWorkshopId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-linea-entregado' | formatLabelPipe
                  : elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{transferStoreWorkshopPrintModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>